module.exports = __webpack_public_path__ + "img/list3.89db26ff.png";